// SSE-over-fetch client. The chat endpoint is POST (not an EventSource GET), so we
// read the response body stream and parse `data:` frames ourselves.

import type { ServerFrame, ChatRequest } from '@marginarc/shared';

export async function streamChat(
  apiBase: string,
  req: ChatRequest,
  onFrame: (f: ServerFrame) => void,
  signal?: AbortSignal,
): Promise<void> {
  const res = await fetch(`${apiBase}/chat`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(req),
    signal,
  });
  if (!res.ok || !res.body) throw new Error(`chat request failed (${res.status})`);

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = '';

  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    let sep: number;
    while ((sep = buf.indexOf('\n\n')) !== -1) {
      const block = buf.slice(0, sep);
      buf = buf.slice(sep + 2);
      const dataLine = block.split('\n').find((l) => l.startsWith('data:'));
      if (!dataLine) continue;
      try {
        onFrame(JSON.parse(dataLine.slice(5).trim()) as ServerFrame);
      } catch {
        /* ignore malformed frame */
      }
    }
  }
}

/** Fire-and-forget analytics ping (never blocks the UI). */
export function postEvent(apiBase: string, event: string, sessionId: string, payload?: Record<string, unknown>): void {
  try {
    void fetch(`${apiBase}/events`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ sessionId, event, pageUrl: location.pathname, payload }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* no-op */
  }
}
